module.exports = __webpack_public_path__ + "static/img/map_bj.a5b8f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/map_bj.png
// module id = uiIV
// module chunks = 2